<template>
  <section class="tip-tabs-box">
    <ul class="list-wrapper clearfix">
      <li
        class="list-item"
        :class="{ active: curIndex === index }"
        v-for="(item, index) in categoryList"
        :key="index"
        @click="onCategoryClick(item, index)"
      >
        <span>{{ item.name }}</span>
      </li>
    </ul>
    <div class="scroll-main fadeInRight" v-if="questionList.length > 0">
      <div class="scroll-main-inner">
        <div class="main-left">
          <div class="main-left-inner">
            <div class="img-box">
              <img src="@/assets/image/question@3x_banner@3x.png" alt />
            </div>
            <div class="btn-box" @click="handleChangeList">
              <img class="icon" src="@/assets/image/change@3x.png" alt />
              <span class="text">换一换</span>
            </div>
          </div>
        </div>
        <ul class="main-lists">
          <div
            class="main-list"
            v-for="(item, index) in questionList"
            :key="index"
            @click="handleRowClick(item)"
          >
            <span class="text">{{ item.title }}</span>
          </div>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { getCategoryList, getQuestionList } from '@/database/index'
export default {
  data () {
    return {
      curIndex: 0,
      categoryList: [],
      questionParams: {
        page: 1,
        rows: 5,
        sort: 'hot',
        categoryId: ''
      },
      questionList: []
    }
  },
  computed: {
    ...mapState(['chatControl'])
  },
  created () {
    const params = {
      page: 1,
      rows: 100,
      sort: 'seq',
      order: 'asc'
    }
    getCategoryList(params).then(res => {
      res.categoryList.unshift({
        name: '全部'
      })
      this.categoryList = res.categoryList
      this.getQuestionList()
    })
  },
  methods: {
    onCategoryClick (item, index) {
      this.curIndex = index
      this.questionParams.page = 1
      this.questionParams.categoryId = item.id
      this.getQuestionList()
    },

    async getQuestionList () {
      this.questionList = []
      const result = await getQuestionList(this.questionParams)
      this.questionList = result.questionList

      if (this.questionList.length <= 0) {
        this.questionParams.page = 1
        this.getQuestionList()
      }
    },

    handleChangeList () {
      this.questionParams.page++
      this.getQuestionList()
    },

    handleRowClick (row) {
      this.chatControl.addInfoArticleById(this.questionList, row)
    }
  }
}
</script>

<style lang="stylus">
.tip-tabs-box {
  border-radius: 10px;
  background: #fff;
  margin-bottom: 25px;
  overflow: hidden;

  .list-wrapper {
    padding: 7px 5px;
  }

  .list-item {
    float: left;
    width: 25%;
    padding: 6px 0;
    text-align: center;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      span {
        padding: 2px;
        font-weight: bolder;
        color: #193a79;
        border-bottom: 1px solid #193a79;
      }
    }
  }

  .scroll-main {
    border-top: 1px solid #eaeaea;
    animation-duration: 0.5s;
    animation-fill-mode: both;

    .scroll-main-inner {
      display: flex;
      padding: 5px 0;

      .main-left {
        display: flex;
        align-items: center;
        flex: 0 0 80px;
        padding-left: 5px;

        .img-box {
          img {
            width: 100%;
          }
        }

        .btn-box {
          text-align: center;
          margin-top: 15px;

          .icon {
            display: inline-block;
            width: 15px;
            position: relative;
            top: 1px;
          }

          .text {
            display: inline-block;
            color: #193a79;
            margin-left: 2px;
          }
        }
      }

      .main-lists {
        flex: 1;
        padding: 0 15px 0 10px;
        box-sizing: border-box;
        min-height: 218px;

        .main-list {
          padding: 7px 0;
          border-bottom: 1px dashed #d0d0d0;

          // color #666
          .text {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/tipTabs.vue